import { React } from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import "../LeadCount/Leadcount.css";

const LeadCount = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [userDetailResponse, setUserDetailResponse] = useState([]);

  const [firstItem, setFirstItem] = useState({
    nextfollowupdatetime: "",
    relocation_date: "",
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };





  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}userget/TotalLeadCount?fromdate=${firstItem.fromDate}&toDate=${firstItem.toDate}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setUserDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  return (
    <div className="d-flex flex-row app lead-count-data">
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <table>
          <tr>
            <td><span>From Date: </span> <input
              className="form-control"
              type="datetime-local"
              name="fromDate"
              value={firstItem.fromDate}
              onChange={handleChange}
            /></td>
            <td><span>To Date: </span> <input
              className="form-control"
              type="datetime-local"
              name="toDate"
              value={firstItem.toDate}
              onChange={handleChange}
            /></td>
            <td>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Update
              </button>

            </td>
          </tr>

        </table>



        <div
          className="d-flex flex-column w-100"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h2>Lead Table</h2>
              <table className="table">
                <thead>
                  <tr>
                    <th>NO.</th>
                    <th>Email</th>
                    <th>Lead Count</th>
                  </tr>
                </thead>
                <tbody>
                  {userDetailResponse !== null ? (
                    userDetailResponse.map((lead, index) => (
                      <tr key={lead.user_id}>
                        <td>{index + 1}</td>
                        <td>{lead.Assigned_To}</td>
                        <td>{lead.LeadCount}</td>
                      </tr>
                    ))
                  ) : (
                    <p>empty</p>
                  )}
                  {/* {leads.map((lead, index) => (
                      <tr key={index}>
                        <td>{lead.email}</td>
                        <td>{lead.leadcount}</td>
                      </tr>
                    ))} */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadCount;
